import { gql } from '@apollo/client';

export const BULK_DELETE_SEQUENCES_V5 = gql`
  mutation bulkDeleteSequencesV5($inputs: [ID!]!) {
    bulkDeleteSequencesV5: bulkDeleteSequencesV5(sequenceIds: $inputs)
  }
`;
